import React, { useEffect } from 'react'
import { Box } from '@mui/material'

import { AppLinksBlock, AppRunProgress } from '@components'
import { reportListCellData, reportListStatus, selectedReportTypeTab } from 'Pages/ReportsAlerts/Reports/@signals'
import { reportSearchesModalId } from '@signals'
import { REPORT_TYPE_TABS } from 'Pages/ReportsAlerts/Reports/@constants'


export default function ReportListTableRunningBlock({ rowData, isExtras }) {

	const { hasDirectSites, hasCompetitionSites, idLastExecution: idReport } = rowData
	const reportData = reportListCellData.value[idReport]
	const isRunning = rowData?.statusLastExecution === 'running'
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING
	const isOneWay = selectedReportTypeTab.value === REPORT_TYPE_TABS.ONE_WAYS

	useEffect(() => {
		if (isRunning && !reportListStatus.value?.includes(idReport)) {
			reportListStatus.value = [...reportListStatus.value, idReport]
		}
	}, [isRunning, idReport])

	const handleClick = () => {
		if (isRunning && !reportData?.generating) {
			reportSearchesModalId.value = idReport
		}
	}

	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 1 }}>
		<AppRunProgress
			label={!reportData?.generating && 'Running'}
			actual={reportData?.percentage}
			total={100}
			done={reportData?.completeTasksString || '…'}
			totalText={reportData?.totalTasksString || '…'}
			generating={reportData?.generating}
			onClick={handleClick}
		/>
		{reportData?.generating && (
			<Box sx={{ mt: 1 }}>
				<AppLinksBlock
					reportExecutionID={idReport}
					hasCompetitionSites={hasCompetitionSites}
					hasDirectSites={hasDirectSites}
					downMultiReport={false}
					downMultiExport={false}
					isExtras={isExtras}
					isRating={isRating}
					isOneWay={isOneWay}
				/>
			</Box>
		)}
	</Box>
}
